import Api from "@/services/Api";

export default {
  indexAvailableByParty(partyId) {
    return Api().get("character_classes/" + partyId + "/available_by_party");
  },
  view(characterClassId) {
    return Api().get("character_classes/" + characterClassId);
  },
  index() {
    return Api().get("character_classes");
  },
  addPerk(characterClassId, form) {
    return Api().put("character_classes/" + characterClassId + "/add_perk", form);
  },
  detachedByCampaign(campaignId) {
    return Api().get("character_classes/detached_by_campaign/" + campaignId);
  }
};